import { TranslateService} from '@ngx-translate/core';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OwlDateTimeIntl,
} from "ng-pick-datetime";

export class DefaultIntl extends OwlDateTimeIntl {
  constructor(private translate: TranslateService) {
    super()
  }
  /** A label for the up second button (used by screen readers).  */
  upSecondLabel = this.translate.instant("Add a second")

  /** A label for the down second button (used by screen readers).  */
  downSecondLabel = this.translate.instant("Minus a second")

  /** A label for the up minute button (used by screen readers).  */
  upMinuteLabel = this.translate.instant("Add a minute")

  /** A label for the down minute button (used by screen readers).  */
  downMinuteLabel = this.translate.instant("Minus a minute")

  /** A label for the up hour button (used by screen readers).  */
  upHourLabel = this.translate.instant("Add a hour")

  /** A label for the down hour button (used by screen readers).  */
  downHourLabel = this.translate.instant("Minus a hour")

  /** A label for the previous month button (used by screen readers). */
  prevMonthLabel = this.translate.instant("Previous month")

  /** A label for the next month button (used by screen readers). */
  nextMonthLabel = this.translate.instant("Next month")

  /** A label for the previous year button (used by screen readers). */
  prevYearLabel = this.translate.instant("Previous year")

  /** A label for the next year button (used by screen readers). */
  nextYearLabel = this.translate.instant("Next year")

  /** A label for the previous multi-year button (used by screen readers). */
  prevMultiYearLabel = this.translate.instant("Previous 21 years")

  /** A label for the next multi-year button (used by screen readers). */
  nextMultiYearLabel = this.translate.instant("Next 21 years")

  /** A label for the 'switch to month view' button (used by screen readers). */
  switchToMonthViewLabel = this.translate.instant("Change to month view")

  /** A label for the 'switch to year view' button (used by screen readers). */
  switchToMultiYearViewLabel = this.translate.instant("Choose month and year")

  /** A label for the cancel button */
  cancelBtnLabel = this.translate.instant("Cancel")

  /** A label for the set button */
  setBtnLabel = this.translate.instant("Set")

  /** A label for the range 'from' in picker info */
  rangeFromLabel = this.translate.instant("From")

  /** A label for the range 'to' in picker info */
  rangeToLabel = this.translate.instant("To")

  /** A label for the hour12 button (AM) */
  hour12AMLabel = this.translate.instant("AM")

  /** A label for the hour12 button (PM) */
  hour12PMLabel = this.translate.instant("PM")
}

export const MY_NATIVE_FORMATS = {
  fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'},
  datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
  timePickerInput: {hour: 'numeric', minute: 'numeric'},
  monthYearLabel: {year: 'numeric', month: 'short'},
  dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
  monthYearA11yLabel: {year: 'numeric', month: 'long'},
};

export const MY_MOMENT_FORMATS = {
  parseInput: 'l LT',
  fullPickerInput: 'L LT',
  datePickerInput: 'l',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
